import React from 'react';

const MarketPanelNiftyOptions = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Nifty Options</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="nifty-options">
            <thead>
              <tr>
                <th>Strike Price</th>
                <th>Call OI</th>
                <th>Put OI</th>
                <th>Call Volume</th>
                <th>Put Volume</th>
                <th>Call LTP</th>
                <th>Put LTP</th>
                <th>Call Change</th>
                <th>Put Change</th>
                <th>Call % Change</th>
                <th>Put % Change</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.strike_price || '-'}</td>
                    <td>{item.call_oi || '-'}</td>
                    <td>{item.put_oi || '-'}</td>
                    <td>{item.call_volume || '-'}</td>
                    <td>{item.put_volume || '-'}</td>
                    <td>{item.call_ltp || '-'}</td>
                    <td>{item.put_ltp || '-'}</td>
                    <td>{item.call_change || '-'}</td>
                    <td>{item.put_change || '-'}</td>
                    <td>{item.call_percent_change || '-'}</td>
                    <td>{item.put_percent_change || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelNiftyOptions; 